module.exports = __webpack_public_path__ + "img/pic5.6af8dfb7.png";